var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 352.74 303.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed1b24;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m216.75,303.27H0c.71-1.94,1.17-3.45,1.8-4.89C37.82,216.19,73.87,134.01,109.91,51.83c6.95-15.86,13.98-31.69,20.79-47.61C132,1.17,133.63-.01,137,0c26.16.13,52.32.12,78.48,0,3.55-.02,5.29,1.29,6.7,4.49,42.84,97.92,85.78,195.8,128.69,293.69.64,1.46,1.09,3,1.88,5.18-2.75.12-4.84.29-6.94.29-27.16.02-54.32-.08-81.48.12-4.29.03-6.42-1.22-8.17-5.24-25.49-58.44-51.15-116.81-76.78-175.19-.79-1.8-1.63-3.57-3.03-6.61-16.71,38.09-32.95,75.13-49.64,113.17,2.87,0,4.77,0,6.68,0,15.83,0,31.66.03,47.49-.05,2.73-.01,4.59.48,5.83,3.36,9.51,22.01,19.2,43.94,28.8,65.9.5,1.16.73,2.43,1.24,4.15Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobe);
export default __webpack_public_path__ + "static/media/adobe.b7979e7db0cf6258ea06e85f8bddf8d6.svg";
export { ForwardRef as ReactComponent };